export default "__VITE_ASSET__D3HV375e__"